import React from 'react'
import classes from './Delivery.module.css'

const Delivery = () => {
  return (
    <div className={classes.delivery}>
      <p>Free delivery over 50€</p>
    </div>
  )
}

export default Delivery
